import { createApp } from '@app/adapters/create-app'
import createStore from '@app/insights/store'
import type { Store } from 'vuex'

import InsightsCompaniesStatus from '@app/insights/components/companies/companies-list-status.vue'
import { App as Application } from 'vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const element = doc.querySelector(
    "[data-behaviour='insights/subnav-right']"
  ) as HTMLElement

  if (element) {
    const {
      allCompaniesCount,
      liteInsights,
      recentSegments,
      remarkTags,
      firmWorkflows,
    } = element.dataset

    const store = createStore(
      allCompaniesCount ? parseInt(allCompaniesCount) : 0,
      liteInsights === 'true',
      recentSegments ? JSON.parse(recentSegments) : [],
      remarkTags ? JSON.parse(remarkTags) : [],
      firmWorkflows ? JSON.parse(firmWorkflows) : []
    ) as Store<unknown>

    const insightStatusApp: Application = createApp(InsightsCompaniesStatus, {
      isLite: liteInsights === 'true',
    })

    insightStatusApp.use(store)
    insightStatusApp.mount(element)
  }
})
